import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyHarvesterPerformancesReport } from './Pages/listing';

export const DailyHarvesterPerformancesReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyHarvesterPerformancesReport} />
    </Fragment>
)